/**
 * SimpleDesignConfig.ts
 * zentrale konfiguration f�r das design-system
 */

import { } from './TabStyleGenerator';

// farbschema f�r eine tab-ebene
export interface TabLevelColors {
    activeColor: string;
    inactiveColor: string;
    hoverColor: string;
    activeBgColor: string;
    inactiveBgColor: string;
    hoverBgColor: string;
}

export type TabLevelName = 'tabTop' | 'tabMiddle' | 'tabBottom' | 'tabVeryBottom';

// hauptkonfiguration
export interface SimpleDesignConfig {
    // allgemein
    websiteBackgroundColor: string;
    fontFamily: string;

    // schriften
    textColor: string;
    headingColor: string;
    headingBold: boolean;

    // header
    headerBgColor: string;
    headerHeight: number;
    headerGradientEnabled: boolean;
    headerGradientColor: string;
    headerGradientAngle: number;
    headerGradientToWhite: boolean;
    headlineMainColor: string;
    headlineSecondColor: string;

    // tabs
    tabStyle: string;
    tabBorderColor: string;
    tabTop: TabLevelColors;
    tabMiddle: TabLevelColors;
    tabBottom: TabLevelColors;
    tabVeryBottom: TabLevelColors;

    // accordion
    accordionBgColor: string;
    accordionActiveBgColor: string;
    accordionTextColor: string;
    accordionContentBgColor: string;
    accordionContentTextColor: string;
    accordionMatchHeader: boolean;

    // buttons
    buttonBgColor: string;
    buttonHoverColor: string;
    buttonTextColor: string;
}

export const defaultTabLevelColors: TabLevelColors = {
    activeColor: '#424242',
    inactiveColor: '#424242',
    hoverColor: '#088A85',
    activeBgColor: '#A9F5F2',
    inactiveBgColor: '#D8D8D8',
    hoverBgColor: '#CEF6F5'
};

// standard-konfiguration basierend auf custom.css
export const defaultDesignConfig: SimpleDesignConfig = {
    websiteBackgroundColor: '#EFFBFB',
    fontFamily: 'Arial',

    textColor: '#000000',
    headingColor: '#424242',
    headingBold: false,

    headerBgColor: '#A9F5F2',
    headerHeight: 200,
    headerGradientEnabled: false,
    headerGradientColor: '#088A85',
    headerGradientAngle: 135,
    headerGradientToWhite: true,
    headlineMainColor: '#424242',
    headlineSecondColor: '#727272',

    tabStyle: 'standard',
    tabBorderColor: '#828282',

    tabTop: {
        activeColor: '#424242',
        inactiveColor: '#424242',
        hoverColor: '#088A85',
        activeBgColor: '#A9F5F2',
        inactiveBgColor: '#D8D8D8',
        hoverBgColor: '#CEF6F5'
    },
    tabMiddle: {
        activeColor: '#424242',
        inactiveColor: '#424242',
        hoverColor: '#088A85',
        activeBgColor: '#CEF6F5',
        inactiveBgColor: '#E6E6E6',
        hoverBgColor: '#D8F6F5'
    },
    tabBottom: {
        activeColor: '#424242',
        inactiveColor: '#424242',
        hoverColor: '#088A85',
        activeBgColor: '#E0F8F7',
        inactiveBgColor: '#EDEDED',
        hoverBgColor: '#E8F9F8'
    },
    tabVeryBottom: {
        activeColor: '#424242',
        inactiveColor: '#424242',
        hoverColor: '#088A85',
        activeBgColor: '#E4FBFA',
        inactiveBgColor: '#F2F2F2',
        hoverBgColor: '#ECFCFB'
    },

    accordionBgColor: '#424242',
    accordionActiveBgColor: '#727272',
    accordionTextColor: '#FFFFFF',
    accordionContentBgColor: '#EFFBFB',
    accordionContentTextColor: '#000000',
    accordionMatchHeader: false,

    buttonBgColor: '#088A85',
    buttonHoverColor: '#077571',
    buttonTextColor: '#FFFFFF'
};

// verf�gbare tab-styles
export const tabStyles = [
    { value: 'folder', label: 'Aktenreiter (Klassisch)', description: '�berlappende Register wie im Aktenschrank' },
    { value: 'browser', label: 'Browser-Tab (Trapez)', description: 'Trapezform wie in Webbrowsern' },
    { value: 'macos-dock', label: 'Dock-Leiste (Glas)', description: 'Transparenter Container mit Unsch�rfe-Effekt' },
    { value: 'pill-layer', label: 'Doppelkontur (Rund)', description: 'Abgerundet mit doppeltem Rahmen-Effekt' },
    { value: 'floating-island', label: 'Insel-Optik (Schwebend)', description: 'Zusammenh�ngende, schwebende Gruppe' },
    { value: 'minimal-pill', label: 'Kontur (Rund)', description: 'Dezenter Rahmen, f�llt sich bei Auswahl' },
    { value: 'neo-brutal', label: 'Kontrastreich (Schatten)', description: 'Harte Kanten mit versetztem Schlagschatten' },
    { value: 'glass-premium', label: 'Milchglas (Premium)', description: 'Edler Frost-Effekt mit Lichtkanten' },
    { value: 'underline', label: 'Minimal (Unterstrichen)', description: 'Reduziert auf eine animierte Linie' },
    { value: 'neon', label: 'Neon-Effekt (Dunkel)', description: 'Leuchtender Rahmen (Ideal f�r dunkle Hintergr�nde)' },
    { value: 'pills', label: 'Pillenform (Gefuellt)', description: 'Vollfl�chig gef�llte, runde Buttons' },
    { value: 'cyber-cut', label: 'Polygon (Futuristisch)', description: 'Eckiges Design mit abgeschnittenen Kanten' },
    { value: 'soft-glow', label: 'Sanftes Leuchten', description: 'Weicher, farbiger Lichtschein ohne harte Kanten' },
    { value: 'segment', label: 'Segment-Steuerung', description: 'Kompakte Umschaltleiste im App-Stil' },
    { value: 'standard', label: 'Standard (Karteikarte)', description: 'Klassischer Reiter mit geraden Kanten' },
];

// nur windows system fonts, abgesehen von Helvetica
export const fontFamilies = [
    { value: 'Arial', label: 'Arial' },
    { value: 'Helvetica', label: 'Helvetica' },
    { value: 'Verdana', label: 'Verdana' },
    { value: 'Tahoma', label: 'Tahoma' },
    { value: 'Trebuchet MS', label: 'Trebuchet MS' },
    { value: 'Segoe UI', label: 'Segoe UI' },
    { value: 'Calibri', label: 'Calibri' },
    { value: 'Georgia', label: 'Georgia' },
    { value: 'Times New Roman', label: 'Times New Roman' },
    { value: 'Cambria', label: 'Cambria' },
    { value: 'Courier New', label: 'Courier New' },
    { value: 'Consolas', label: 'Consolas' }
];

export const tabLevelLabels: { [key in TabLevelName]: string } = {
    tabTop: 'Ebene 1 (Oben)',
    tabMiddle: 'Ebene 2 (Mitte)',
    tabBottom: 'Ebene 3 (Unten)',
    tabVeryBottom: 'Ebene 4 (Ganz Unten)'
};

// synchronisiert alle tab-ebenen auf eine quell-ebene
export function syncAllTabLevels(
    config: SimpleDesignConfig,
    sourceLevel: TabLevelName
): SimpleDesignConfig {
    var sourceColors: TabLevelColors = config[sourceLevel];

    return {
        ...config,
        tabTop: { ...sourceColors },
        tabMiddle: { ...sourceColors },
        tabBottom: { ...sourceColors },
        tabVeryBottom: { ...sourceColors }
    };
}

// setzt accordion-farben auf header-farben
export function syncAccordionToHeader(config: SimpleDesignConfig): SimpleDesignConfig {
    return {
        ...config,
        accordionBgColor: config.headerBgColor,
        accordionActiveBgColor: config.headerGradientEnabled
            ? config.headerGradientColor
            : config.headerBgColor,
        accordionMatchHeader: true
    };
}

// erstellt farbhierarchie basierend auf basis-farben
export function createColorHierarchy(
    baseActiveColor: string,
    baseActiveBgColor: string
): {
    tabTop: TabLevelColors;
    tabMiddle: TabLevelColors;
    tabBottom: TabLevelColors;
    tabVeryBottom: TabLevelColors;
} {
    var lighten = function (hex: string, percent: number): string {
        var cleanHex = hex.replace('#', '');
        var num = parseInt(cleanHex, 16);
        var r = (num >> 16) + Math.round(255 * percent / 100);
        var g = ((num >> 8) & 0x00FF) + Math.round(255 * percent / 100);
        var b = (num & 0x0000FF) + Math.round(255 * percent / 100);

        var newR = Math.min(255, r);
        var newG = Math.min(255, g);
        var newB = Math.min(255, b);

        return '#' + newR.toString(16).padStart(2, '0') +
            newG.toString(16).padStart(2, '0') +
            newB.toString(16).padStart(2, '0');
    };

    return {
        tabTop: {
            activeColor: baseActiveColor,
            inactiveColor: '#424242',
            hoverColor: lighten(baseActiveColor, 20),
            activeBgColor: baseActiveBgColor,
            inactiveBgColor: '#E8E8E8',
            hoverBgColor: lighten(baseActiveBgColor, 10)
        },
        tabMiddle: {
            activeColor: baseActiveColor,
            inactiveColor: '#424242',
            hoverColor: lighten(baseActiveColor, 20),
            activeBgColor: lighten(baseActiveBgColor, 15),
            inactiveBgColor: '#E8E8E8',
            hoverBgColor: lighten(baseActiveBgColor, 25)
        },
        tabBottom: {
            activeColor: baseActiveColor,
            inactiveColor: '#424242',
            hoverColor: lighten(baseActiveColor, 20),
            activeBgColor: lighten(baseActiveBgColor, 30),
            inactiveBgColor: '#F0F0F0',
            hoverBgColor: lighten(baseActiveBgColor, 40)
        },
        tabVeryBottom: {
            activeColor: '#64748b',
            inactiveColor: '#94a3b8',
            hoverColor: '#475569',
            activeBgColor: lighten(baseActiveBgColor, 45),
            inactiveBgColor: '#F8F8F8',
            hoverBgColor: lighten(baseActiveBgColor, 55)
        }
    };
}

// --- legacy-css parser ---
// konvertiert css-variablen aus dbo.texte (plantyp 3) zu config

function lightenColor(hex: string, percent: number): string {
    if (!hex || hex.length === 0) {
        return '#FFFFFF';
    }

    var cleanHex = hex.replace('#', '');

    if (cleanHex.length === 3) {
        cleanHex = cleanHex[0] + cleanHex[0] + cleanHex[1] + cleanHex[1] + cleanHex[2] + cleanHex[2];
    }

    var num = parseInt(cleanHex, 16);
    if (isNaN(num)) {
        return hex;
    }

    var r = (num >> 16) + Math.round(255 * percent / 100);
    var g = ((num >> 8) & 0x00FF) + Math.round(255 * percent / 100);
    var b = (num & 0x0000FF) + Math.round(255 * percent / 100);

    r = Math.min(255, Math.max(0, r));
    g = Math.min(255, Math.max(0, g));
    b = Math.min(255, Math.max(0, b));

    return '#' + r.toString(16).padStart(2, '0') +
        g.toString(16).padStart(2, '0') +
        b.toString(16).padStart(2, '0');
}

export function extractCSSVariables(cssText: string): { [varName: string]: string } {
    var variables: { [varName: string]: string } = {};

    if (!cssText || cssText.length === 0) {
        return variables;
    }

    var varRegex = /--([a-zA-Z0-9_-]+)\s*:\s*([^;]+);/g;

    var match: RegExpExecArray | null;
    while ((match = varRegex.exec(cssText)) !== null) {
        var varName = '--' + match[1].trim();
        var varValue = match[2].trim();
        variables[varName] = varValue;
    }

    return variables;
}

export function hasValidCSSVariables(cssText: string): boolean {
    if (!cssText || cssText.length === 0) {
        return false;
    }

    var variables = extractCSSVariables(cssText);

    var importantVars = [
        '--colHintergrund',
        '--colSchriftNavAktiv',
        '--colTabObenAktiv',
        '--colHintergrundAccordion'
    ];

    for (var i = 0; i < importantVars.length; i++) {
        if (variables[importantVars[i]]) {
            return true;
        }
    }

    return false;
}

// mappt legacy css-variablen auf config-properties
export function parseLegacyCSSToConfig(cssText: string): SimpleDesignConfig {
    var variables = extractCSSVariables(cssText);
    var config: SimpleDesignConfig = JSON.parse(JSON.stringify(defaultDesignConfig));

    var getVar = function (varName: string, defaultValue: string): string {
        return variables[varName] || defaultValue;
    };

    config.websiteBackgroundColor = getVar('--colHintergrund', config.websiteBackgroundColor);

    // header - gradient-farbe entspricht --colTabObenAktiv im legacy-css
    config.headerBgColor = getVar('--colTabObenAktiv', config.headerBgColor);
    config.headerGradientToWhite = true;
    config.headerGradientEnabled = false;
    config.headerHeight = 200;

    config.headlineMainColor = getVar('--colSchriftHeadlineMain', config.headlineMainColor);
    config.headlineSecondColor = getVar('--colSchriftHeadlineScond', config.headlineSecondColor);
    config.headingBold = false;

    config.accordionTextColor = getVar('--colSchriftAccordion', config.accordionTextColor);
    config.accordionContentTextColor = getVar('--colSchriftAccordionContent', config.accordionContentTextColor);
    config.accordionContentBgColor = getVar('--colSchriftAccordionContentHintergrund', config.accordionContentBgColor);
    config.accordionBgColor = getVar('--colHintergrundAccordion', config.accordionBgColor);
    config.accordionActiveBgColor = getVar('--colHintergrundAccordionAktiv', config.accordionActiveBgColor);
    config.accordionMatchHeader = false;

    config.tabBorderColor = getVar('--colTabActiveBolder', config.tabBorderColor);
    config.tabStyle = 'standard';

    var navAktiv = getVar('--colSchriftNavAktiv', defaultDesignConfig.tabTop.activeColor);
    var navInaktiv = getVar('--colSchriftNavInaktiv', defaultDesignConfig.tabTop.inactiveColor);
    var navHover = getVar('--colSchriftNavHover', defaultDesignConfig.tabTop.hoverColor);

    var tabObenAktiv = getVar('--colTabObenAktiv', defaultDesignConfig.tabTop.activeBgColor);
    var tabObenInaktiv = getVar('--colTabObenInaktiv', defaultDesignConfig.tabTop.inactiveBgColor);
    config.tabTop = {
        activeColor: navAktiv,
        inactiveColor: navInaktiv,
        hoverColor: navHover,
        activeBgColor: tabObenAktiv,
        inactiveBgColor: tabObenInaktiv,
        hoverBgColor: lightenColor(tabObenAktiv, 10)
    };

    var tabMitteAktiv = getVar('--colTabMitteAktiv', defaultDesignConfig.tabMiddle.activeBgColor);
    var tabMitteInaktiv = getVar('--colTabMitteInaktiv', defaultDesignConfig.tabMiddle.inactiveBgColor);
    config.tabMiddle = {
        activeColor: navAktiv,
        inactiveColor: navInaktiv,
        hoverColor: navHover,
        activeBgColor: tabMitteAktiv,
        inactiveBgColor: tabMitteInaktiv,
        hoverBgColor: lightenColor(tabMitteAktiv, 10)
    };

    var tabUntenAktiv = getVar('--colTabUntenAktiv', defaultDesignConfig.tabBottom.activeBgColor);
    var tabUntenInaktiv = getVar('--colTabUntenInaktiv', defaultDesignConfig.tabBottom.inactiveBgColor);
    config.tabBottom = {
        activeColor: navAktiv,
        inactiveColor: navInaktiv,
        hoverColor: navHover,
        activeBgColor: tabUntenAktiv,
        inactiveBgColor: tabUntenInaktiv,
        hoverBgColor: lightenColor(tabUntenAktiv, 10)
    };

    var tabGanzUntenAktiv = getVar('--colTabGanzUntenAktiv', defaultDesignConfig.tabVeryBottom.activeBgColor);
    var tabGanzUntenInaktiv = getVar('--colTabGanzUntenInaktiv', defaultDesignConfig.tabVeryBottom.inactiveBgColor);
    config.tabVeryBottom = {
        activeColor: navAktiv,
        inactiveColor: navInaktiv,
        hoverColor: navHover,
        activeBgColor: tabGanzUntenAktiv,
        inactiveBgColor: tabGanzUntenInaktiv,
        hoverBgColor: lightenColor(tabGanzUntenAktiv, 10)
    };

    config.buttonBgColor = getVar('--colButtonBackground', config.buttonBgColor);
    config.buttonHoverColor = getVar('--colButtonBackgroundHover', config.buttonHoverColor);
    config.buttonTextColor = defaultDesignConfig.buttonTextColor;

    return config;
}
